import { lazy, Suspense } from 'react'
import { useNavigate } from 'react-router-dom'
import CalculatorWorkspace from '@/components/calculator/CalculatorWorkspace'
import DemoLoggedInBanner from '@/components/demo/DemoLoggedInBanner'
import useAppShellLock from '@/hooks/useAppShellLock'
import { getStudioHref, navigateToPublicPath } from '@/lib/hostRouting'
import { getSeoForPath } from '@/lib/seo'

// Lazy so the assistant bundle only loads on the demo when the flag is on.
const AssistantFeature = lazy(() => import('@/features/assistant/AssistantFeature'))

const DEMO_TITLE = getSeoForPath('/demo').title
const CFO_TITLE = getSeoForPath('/cfo').title

// `cfoMode` renders the same demo workspace with the CFO cost summary in
// place of the standard Summary section (the /cfo route).
export default function DemoShell({ cfoMode = false }) {
  useAppShellLock()
  const navigate = useNavigate()
  const goPublic = (path) => navigateToPublicPath(path, navigate)
  const studioHref = getStudioHref('/')

  return (
    <div className="flex h-screen h-[100dvh] flex-col bg-background text-foreground">
      <h1 className="sr-only">{cfoMode ? '401(k) cost calculator for CFOs' : '401(k) plan design calculator demo'}</h1>
      {/* Signed-in users get pointed at the matching studio surface: the CFO
          view has its own studio subroute where their work persists. */}
      <DemoLoggedInBanner
        studioHref={cfoMode ? getStudioHref('/cfo') : studioHref}
        surfaceLabel={cfoMode ? 'the public CFO view' : 'the demo'}
      />
      <div className="min-h-0 flex-1">
        <CalculatorWorkspace
          documentTitle={cfoMode ? CFO_TITLE : DEMO_TITLE}
          onLogoClick={() => goPublic('/')}
          onContactClick={() => goPublic('/contact')}
          onPrivacyClick={() => goPublic('/privacy')}
          loginHref={getStudioHref('/login')}
          demoMode
          cfoMode={cfoMode}
          studioHref={studioHref}
        />
      </div>
      <Suspense fallback={null}>
        <AssistantFeature demoMode loginHref={getStudioHref('/login')} showTrigger={false} />
      </Suspense>
    </div>
  )
}
